import React, { useEffect, useState } from "react";
import "./UnitNameCell.css";
import {
  // eslint-disable-next-line
  BeforeTaxInput,
  UnitContainer,
  UnitInput,
  UnitNameInput,
} from "../../Styled";
import {
  priceAfterTax,
  totalPrice,
} from "../../../../../commonFuntions/CommonUtilFunctions";
// eslint-disable-next-line
import { InputSelectBeforeTax } from "../../../../../components/Input/InputSelectBeforeTax/InputSelectBeforeTax";

const StockUnitNameCell = ({
  dataSource,
  tableIndex,
  params,
  record,
  setDataSource,
}) => {
  const [unitName, setUnitName] = useState("");
  const [beforeTax, setBeforeTax] = useState("");
  const [hsn, setHsn] = useState("");
  // eslint-disable-next-line
  const [pricePrefix, setPricePrefix] = useState("");
  // eslint-disable-next-line
  const [selected, setSelected] = useState("");

  const handleUnitName = (value) => {
    setUnitName(value);
  };

  const handleHsn = (e) => {
    const value = e.target.value.split(" ");
    const updatedValue = value[2] || "";

    setHsn(updatedValue);
  };
  const handleSave = (check, check2, price) => {
    const samePreviusValue =
      Number(record?.before_tax || 0) === Number(beforeTax || 0);
    const afterTax = priceAfterTax({
      gst: record?.gst,
      before_tax: check2 === "select_tax" ? price : beforeTax,
    });
    const total = totalPrice({
      gst: record?.gst,
      before_tax: check2 === "select_tax" ? price : beforeTax,
      discount: check === "before_tax" ? 0 : record?.discount,
      quantity: record?.quantity,
    });
    const bmp =
      check === "before_tax" && !samePreviusValue
        ? record?.amount_in === "amount"
          ? parseFloat(afterTax || 0) * parseFloat(record?.quantity || 0)
          : (parseFloat(afterTax || 0) * parseFloat(record?.quantity || 0)) /
            (1 + parseFloat(0) / 100)
        : record?.amount_in === "amount"
        ? parseFloat(afterTax || 0) * parseFloat(record?.quantity || 0) -
          parseFloat(record?.amount || 0)
        : (parseFloat(afterTax || 0) * parseFloat(record?.quantity || 0)) /
          (1 + parseFloat(record?.amount || 0) / 100);

    // const bmp =
    //   check === "before_tax"
    //     ? 0
    //     : record.amount_in === "amount"
    //     ? parseFloat(total) - parseFloat(record.amount || 0)
    //     : parseFloat(total) / (1 + parseFloat(record.amount || 0) / 100);
    setDataSource((prevData) => {
      return prevData?.map((table, index) => {
        return tableIndex === index
          ? table?.map((item) => {
              if (item?.key === record?.key) {
                return {
                  ...item,
                  unit_name: unitName,
                  before_tax: check2 === "select_tax" ? price : beforeTax,
                  hsn_sac: hsn,
                  after_tax: afterTax,
                  total: total,
                  bmp_price: bmp,
                  ...(check === "before_tax" && {
                    discount: samePreviusValue ? record?.discount : 0,
                    amount: samePreviusValue ? record?.amount : 0,
                  }),
                };
              }
              return item;
            })
          : table;
      });
    });
  };
  useEffect(() => {
    setUnitName(record?.unit_name);
    setBeforeTax(parseFloat(record?.before_tax || 0).toFixed(4));
    setHsn(record?.hsn_sac);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);
  useEffect(() => {
    if (record?.mob_sku) {
      setPricePrefix("RFQ");
      setSelected(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record?.mob_sku]);
  return (
    <>
      <UnitContainer>
        <UnitNameInput
          className="custum_input w-100"
          placeholder="Enter Unit"
          value={unitName}
          onChange={(e) => handleUnitName(e.target.value)}
          onPressEnter={handleSave}
          onBlur={handleSave}
        />
      </UnitContainer>
      <UnitInput
        value={`HSN Code: ${hsn ? hsn : ""}`}
        onChange={handleHsn}
        onPressEnter={handleSave}
        onBlur={handleSave}
      />
    </>
  );
};
export default StockUnitNameCell;
